import { Link } from "react-router-dom";

import Legend from "./Legend";

/*
const i =
  type === "approved"
    ? "fa-check-circle-o"
    : type === "pending"
    ? "fa-hourglass-o"
    : "fa-times-circle-o";
  */

const TdDayHdg = ({ d }) => {
	return (
		<td className="center" style={{ width: "3.5%", fontSize: "0.9rem" }}>
			{d}
		</td>
	);
};

const TdDayVal = ({ status }) => {
	const i = status === 1 ? "fa-check" : "fa-hourglass-o";

	return (
		<td className="center" style={{ verticalAlign: "middle" }}>
			<span
				className={
					status === 1 ? "success" : status === 2 ? "working" : "invisible"
				}
			>
				<div style={{ fontSize: "1rem", paddingTop: "4px" }}>
					<i className={`fa ${i}`}></i>
				</div>
			</span>
		</td>
	);
};

const TdConfirmedVal = ({ status, inProcess, text }) => {
	return (
		<td>
			{text ? (
				<span className="success">{text}</span>
			) : inProcess ? (
				<span className="notice">in process</span>
			) : status === 1 ? (
				<span className="notice">approved</span>
			) : (
				<span className="working">pending</span>
			)}
		</td>
	);
};

const Table1 = ({ type, text, data }) => {
	return (
		<table
			className="approved assigned"
			style={{ marginTop: "0", marginBottom: "25px" }}
		>
			<thead>
				<tr>
					<th colSpan="15" className="hdg">
						<p>{text}</p>
						<small style={{ fontWeight: "normal" }}>
							Click icon to edit or delete a request (in process requests cannot
							be edited)
						</small>

						<Legend type="approvedPending" />
					</th>
				</tr>
			</thead>
			<thead>
				<tr>
					<td
						className="spot"
						rowSpan="2"
						style={{ width: "6%", paddingTop: "0", paddingBottom: "0" }}
					>
						ID
					</td>
					<td
						className="spot"
						colSpan="2"
						rowSpan="2"
						style={{ width: "10%", paddingTop: "0", paddingBottom: "0" }}
					>
						Edit / Delete
					</td>

					<td
						className="center"
						rowSpan="2"
						style={{ width: "27%", paddingTop: "0", paddingBottom: "0" }}
					>
						Occupant
					</td>
					<td
						className="center"
						rowSpan="2"
						style={{ width: "16%", paddingTop: "0", paddingBottom: "0" }}
					>
						Hotel / Room
					</td>

					<td className="center" colSpan="9">
						March 29 - April 6
					</td>
					<td
						className="center"
						rowSpan="2"
						style={{
							paddingTop: "0",
							paddingBottom: "0",
						}}
					>
						Confirmation
						<br />
						Number
					</td>
				</tr>
				<tr>
					<TdDayHdg d="S" />
					<TdDayHdg d="M" />
					<TdDayHdg d="T" />
					<TdDayHdg d="W" />
					<TdDayHdg d="T" />
					<TdDayHdg d="F" />
					<TdDayHdg d="S" />
					<TdDayHdg d="S" />
					<TdDayHdg d="M" />
				</tr>
			</thead>
			{data.length > 0 ? (
				<tbody>
					{data.map((item) => {
						return (
							<tr key={`${item.id}`}>
								<td className="spot">{item.id}</td>

								<td>
									{item.confirmation ? (
										<Link to={`/dashboard/hotel/confirmed/${item.encryptedId}`}>
											<i className="fa fa-pencil"></i>
										</Link>
									) : item.inProcess ? (
										<i
											className="fa fa-pencil working"
											style={{ cursor: "not-allowed" }}
										></i>
									) : item.status === 2 ? (
										<Link to={`/dashboard/hotel/edit/${item.encryptedId}`}>
											<i className="fa fa-pencil"></i>
										</Link>
									) : (
										<i
											className="fa fa-pencil working"
											style={{ cursor: "not-allowed" }}
										>
											{/* hack to disable date changes for approved after closed
												<Link to={`/dashboard/hotel/edit/${item.encryptedId}`}>
											<i className="fa fa-pencil"></i>
									</Link>
										*/}
										</i>
									)}
								</td>

								<td style={{ fontSize: "1.1rem" }}>
									{item.inProcess ? (
										<i
											className="fa fa-trash working"
											style={{ cursor: "not-allowed" }}
										></i>
									) : (
										<Link to={`/dashboard/hotel/delete/${item.encryptedId}`}>
											<i className="fa fa-trash error"></i>
										</Link>
									)}
								</td>

								<td className="left">
									{item.changePending ? (
										<span
											className="working"
											title="Pending name change for this request"
										>
											<i className="fa fa-hourglass-o fa-md" /> &nbsp;
											{item.occupant}
										</span>
									) : (
										<span>{item.occupant}</span>
									)}
								</td>
								<td className="left">{item.hotel}</td>
								<TdDayVal status={item.sun1} />
								<TdDayVal status={item.mon1} />
								<TdDayVal status={item.tue1} />
								<TdDayVal status={item.wed1} />
								<TdDayVal status={item.thu1} />
								<TdDayVal status={item.fri1} />
								<TdDayVal status={item.sat1} />
								<TdDayVal status={item.sun2} />
								<TdDayVal status={item.mon2} />
								<TdConfirmedVal
									status={item.status}
									inProcess={item.inProcess}
									text={item.confirmation}
								/>
							</tr>
						);
					})}
				</tbody>
			) : (
				<tbody>
					<tr>
						<td colSpan="15">
							<span className="working">-- no requests found --</span>
						</td>
					</tr>
				</tbody>
			)}
		</table>
	);
};

export default Table1;
